import router from './router';
import { activatePortalTheme } from '@/utils/portal-theme';
import { clearLegacyPortalCredentialCache } from '@/utils/portal-auth';
import { getPortalToken } from '@/utils/portal-auth';

router.beforeEach((to) => {
  const portal = to.path.startsWith('/open-portal');
  document.documentElement.classList.toggle('open-portal-page', portal);
  activatePortalTheme(portal);
  if (portal) {
    clearLegacyPortalCredentialCache();
    const titles: Record<string, string> = {
      '/open-portal/login': '登录',
      '/open-portal/admin': '用户与 AppKey',
      '/open-portal/admin/applications': '应用管理'
    };
    document.title = `${titles[to.path] || '控制台'} · Nexus 开放平台`;
    if (to.path === '/open-portal/login' || getPortalToken()) return true;
    return { path: '/open-portal/login', query: { redirect: to.fullPath } };
  }
  return { path: '/open-portal/index' };
});
